module.exports = __webpack_public_path__ + "img/Kebab wrap Icon - white.357d815b.svg";